/* eslint-disable react/destructuring-assignment */
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Fab, Grid, Typography } from '@mui/material';
import { PropsWithChildren, ReactNode, useState } from 'react';
import { FormattedMessage } from 'react-intl';

export type FormSectionProps = {
    title?: string;
    rightAction?: ReactNode;
    isChild?: boolean;
    additionalTitle?: ReactNode;
} & ({ collapsible?: undefined } | { collapsible: true; defaultOpen?: boolean; btnTabIndex?: number });

export const FormSection = (props: PropsWithChildren<FormSectionProps>) => {
    const { title, rightAction, children, isChild, collapsible, additionalTitle } = props;
    const [isOpen, setIsOpen] = useState(!!((collapsible && !!props.defaultOpen) || !collapsible));

    return (
        <Box
            component="section"
            sx={{
                my: '12px',
                padding: isChild ? '2px 12px' : '8px 24px',
                border: 'solid 1px #EBEEFE',
                borderRadius: '8px',
                pb: isChild && isOpen ? '12px' : '8px'
            }}
        >
            <Grid container alignItems="center" sx={{ mb: isChild ? 0 : '5px' }}>
                <Grid item container xs={9} spacing={1} alignItems="center">
                    <Grid item xs="auto">
                        <Typography variant="h4" fontSize={isChild ? '14px' : '20px'} fontWeight={500} color="#37326E">
                            {title && <FormattedMessage id={title} defaultMessage={title} />}
                        </Typography>
                    </Grid>
                    <Grid item xs="auto" alignSelf="flex-end">
                        {additionalTitle}
                    </Grid>
                </Grid>

                <Grid item xs={3}>
                    {rightAction}
                    {collapsible && (
                        <Fab
                            sx={{
                                float: 'right',
                                width: '40px',
                                height: '40px',
                                mb: '2px',
                                boxShadow: 'none !important',
                                bgcolor: isOpen ? '#EBEEFE !important' : '#F5F6F7 !important'
                            }}
                            tabIndex={props.btnTabIndex}
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            {isOpen ? (
                                <ExpandLess sx={{ fontSize: '30px' }} htmlColor="#37326E" />
                            ) : (
                                <ExpandMore sx={{ fontSize: '30px' }} htmlColor="#858585" />
                            )}
                        </Fab>
                    )}
                </Grid>
            </Grid>

            {isOpen ? children : undefined}
        </Box>
    );
};
